import { useNavigate } from "@tanstack/react-router";
import { RefineUploadTray } from "@studio-features/meta-crew/refine-upload-tray";
import { refineUploadQueue, useRefineUploadQueue } from "../lib/upload-queue";

/**
 * 정형화 업로드 트레이 (요청서 34절, 시안 7d124a1). 셸에 두어 화면을 옮겨도 남는다. 큐는 src/lib/upload-queue.ts 가 맡고 여기서는 보여 주기만 한다.
 * "목록 보기" 는 만든 작업만 정형화 탭에서 (?ids=).
 */
export function UploadTray() {
  const navigate = useNavigate();
  const view = useRefineUploadQueue();
  if (!view.batches.length && !view.notice) return null;
  return (
    <RefineUploadTray
      view={view}
      actions={{
        retry: refineUploadQueue.retry,
        cancel: refineUploadQueue.cancel,
        dismiss: refineUploadQueue.dismiss,
        dismissNotice: refineUploadQueue.dismissNotice,
        openList: (ids) => {
          refineUploadQueue.dismissNotice();
          void navigate({ to: "/admin/$screen", params: { screen: "refine" }, search: (ids.length ? { ids: ids.join(",") } : {}) as never });
        },
      }}
    />
  );
}
